import { render, staticRenderFns } from "./UploadAvatar.vue?vue&type=template&id=46156b32&scoped=true&"
import script from "./UploadAvatar.vue?vue&type=script&lang=js&"
export * from "./UploadAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46156b32",
  null
  
)

export default component.exports